import React from 'react';

import { capitalize } from '../../functions/type-functions';
import { CurrencyDetails, Piwik, SiteCoreDictionary } from '../../types';

import './CurrencySelectorClicker.scss';

interface CurrencySelectorClickerProps {
    selectedCurrency: CurrencyDetails | undefined;
    onClick: () => void;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const CurrencySelectorClicker = ({ selectedCurrency, onClick, dictionary, piwik }: CurrencySelectorClickerProps) => {
    const { visaCalculatorCurrencyNotSelected } = dictionary;

    return (
        <button
            className="select-currency sgw-input__input"
            data-track-id={piwik?.visaCalculator?.visaExchangeCalculatorSelectCurrency?.dataTrackId}
            data-track-linkname={piwik?.visaCalculator?.visaExchangeCalculatorSelectCurrency?.dataTrackLinkname}
            id={piwik?.visaCalculator?.visaExchangeCalculatorSelectCurrency?.dataTrackId}
            name="select-currency"
            onClick={() => onClick()}
            type="button"
        >
            {selectedCurrency ? capitalize(selectedCurrency.displayName) : visaCalculatorCurrencyNotSelected}
        </button>
    );
};

export default CurrencySelectorClicker;
